// extracted by mini-css-extract-plugin
module.exports = {"row":"PvPaperWidths_row__dpjsE","button":"PvPaperWidths_button__2TAl7","active":"PvPaperWidths_active__3cw9N"};